import toast from "react-hot-toast";
import { getLocalStorage } from "../../Utils/storage-utils";
import { decryptFromURL } from "../Login/encryption-utils";
import { getRoutObjByKey } from "./sidebarUtils";

export const redirectToFams = (returnUrl = "cable-monitoring", params = null) => {
  const FAMS_URL = getRoutObjByKey("FAMS_RE").url;
  try {
    const cred = getLocalStorage("en_cr", null);
    decryptFromURL(cred);
    let _url = FAMS_URL + `?auth=${cred}`;
    if (returnUrl) {
      _url = _url + `&returnUrl=${returnUrl}`;
    }
    if (params) {
      _url = _url + `&redirParams=${encodeURIComponent(JSON.stringify(params))}`;
    }
    window.open(_url, "_blank");
    return { success: true };
  } catch (err) {
    return { success: false, err: err };
  }
};
